export const floating = (name:string, timing:number, delay?:number) => {
  return `
    animation-name: ${name};
    animation-duration: ${timing}s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-delay: ${delay ? `${delay}s`: `0s`};
  `
}
